import { useEffect, useState } from 'react';
export interface GameInfo {
    gameID: string,
    gameName: string,
    provider: string,
    gameType: number,
    frbAvailable: boolean,
    inMaintence: boolean,
    isHot: boolean,
    isNew: boolean,
    hasFeatureBuy: boolean,
}

export default function GameCard({ isDisable, game, playGame }: { isDisable: boolean, game: GameInfo, playGame: (gameID: string) => void }) {
    const prefixImageURL = "https://static.pragmatic-play-games.com/gs2c/lobby/icons";
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isDisable)
            setLoading(isDisable)
    }, [isDisable])

    return (
        <>
            {/* Game Image */}
            <div className="w-full aspect-[3/4] overflow-hidden">
                <img
                    src={`${prefixImageURL}/${game.gameID}/${game.gameID}_narrow.jpg`}
                    alt={game.gameName}
                    className="w-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
            </div>

            {/* Tags */}
            <div className="absolute top-1 sm:top-1.5 md:top-2 right-1 sm:right-1.5 md:right-2 flex flex-col gap-0.5 md:gap-1">
                {game.isHot && (
                    <span className="bg-gradient-to-r from-red-500 to-orange-500 text-white text-[9px] sm:text-[10px] md:text-xs font-bold px-1 sm:px-1.5 md:px-2 py-0.5 md:py-1 rounded-sm sm:rounded-md" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        HOT
                    </span>
                )}
                {game.isNew && (
                    <span className="bg-gradient-to-r from-[#29A5FF] to-[#4B3FAE] text-white text-[9px] sm:text-[10px] md:text-xs font-bold px-1 sm:px-1.5 md:px-2 py-0.5 md:py-1 rounded-sm sm:rounded-md" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        NEW
                    </span>
                )}
                {game.hasFeatureBuy && (
                    <span className="bg-gradient-to-r from-[#EFBF65] to-[#FFC107] text-[#061B3A] text-[8px] sm:text-[9px] md:text-[10px] font-bold px-1 sm:px-1.5 md:px-2 py-0.5 md:py-1 rounded-sm sm:rounded-md leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        FEATURE
                    </span>
                )}
            </div>

            {/* Game Info */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/90 to-transparent p-1.5 sm:p-2 md:p-3">
                <h3 className="text-white font-semibold text-[10px] sm:text-xs md:text-sm mb-0.5 md:mb-1 truncate" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {game.gameName}
                </h3>
                <p className="text-white/60 text-[9px] sm:text-[10px] md:text-xs mb-1 sm:mb-1.5 md:mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {game.provider ?? "Pragmatic"}
                </p>
                <button disabled={isDisable}  onClick={() => { setLoading(true); playGame(game.gameID) }} className="w-full bg-[#EFBF65] hover:bg-[#FFC107] hover:shadow-[0px_0px_14px_rgba(239,191,101,0.60)] text-[#061B3A] font-bold text-[10px] sm:text-xs md:text-sm py-1 sm:py-1.5 md:py-2 rounded-md sm:rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {loading ? <i className="ri-loader-4-line animate-spin"></i> : 'Play Now'}
                </button>
            </div>

            {/* Glow Effect */}
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-[#EFBF65]/10 via-transparent to-[#29A5FF]/10"></div>
            </div>
        </>
    )
}